import React from 'react';
import { RetirementSystem } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import Flex from 'ui/Flex/Flex';
import AgentArrivalSelector from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/AddHypotheses/components/AgentArrivalSelector';
import { FormState } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Arrival/AgentArrivalHypothesisModal/AgentArrivalForm';
import GradeSelector from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/AddHypotheses/components/GradeSelector';
import EchelonSelector from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/AddHypotheses/components/EchelonSelector';
import { GridEchelons } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/EchelonsOverview/helpers/types';
import { t } from 'i18next';

type Props = {
    officialGrades: GridEchelons[];
    formState: FormState;
    setFormState: React.Dispatch<React.SetStateAction<FormState>>;
};
export const AgentArrivalHypothesisIndiciaireStep = ({
    formState,
    officialGrades,
    setFormState,
}: Props): React.ReactElement => {
    return (
        <Flex
            flexDirection="column"
            sx={{
                marginTop: '1em',
                gap: '2em',
            }}
        >
            <AgentArrivalSelector
                value={formState.filiere}
                formState={formState}
                setFormState={setFormState}
                label={t('humanResources.simulation.filiere')}
                valueType="filiere"
                dataList={Array.from(
                    new Set(officialGrades.map((item) => item.filiere)),
                )}
            />
            <GradeSelector
                selectedGradeSelector={formState.officialGrade}
                formState={formState}
                setFormState={setFormState}
                gradeList={officialGrades
                    .filter((item) => item.filiere === formState.filiere)
                    .map((item) => item.grade)}
            />

            <EchelonSelector
                echelonList={officialGrades
                    .filter(
                        (item) =>
                            item.filiere === formState.filiere &&
                            item.grade === formState.officialGrade,
                    )
                    .map((item) => item.echelon)}
                formState={formState}
                setFormState={setFormState}
            />
            <AgentArrivalSelector
                value={formState.retirementSystem}
                formState={formState}
                setFormState={setFormState}
                label={t('humanResources.simulation.addAgent.retirementSystem')}
                valueType="retirementSystem"
                dataList={Object.values(RetirementSystem)}
            />
        </Flex>
    );
};
